import Router from 'vue-router';

import DMLandingPage from './DMLandingPage.vue';
import VerificationPage from './VerificationPage.vue';
import ApplicationPage from './ApplicationPage.vue';
import store from '../../store/direct_mail/index.js';

const router = new Router({
  mode:   'history',
  base:   'offers',
  routes: [
    {
      path:      '/',
      name:      'dm-landing-page',
      component: DMLandingPage,
    },
    {
      path:      '/verify',
      name:      'verify-offer-page',
      component: VerificationPage,
    },
    {
      path:      '/apply',
      name:      'dm-apply-page',
      component: ApplicationPage,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'dm-landing-page' &&
      store.getters['firstName'].length === 0) next('/')
  else next()
})
export default router;
